import { OPEN_API_TEST, OPEN_API_PRO, BASE_URL } from "@/constants/index";
// 库存查询
export function queryInventoryApi() {
  const apiUrlTest = "/gateway/edi/product/upsert"; //测试环境接口地址
  // const isCn = (localStorage.getItem("lang") || "CN") === "CN";
  return {
    //当前请求URL
    apiBaseUrl: BASE_URL + `${apiUrlTest}`,

    onlineData: {
      // 接口描述
      apiDesc: "apiDocDesc.inventoryqueryapiDesc",
      //接口地址
      testApi: `${OPEN_API_TEST}${apiUrlTest}`,
      proApi: `${OPEN_API_PRO}${apiUrlTest}`,
      infos: [
        [
          {
            key: "apiDocDesc.testUrl",
            value:
              "https://demo-sop.jtfulfillment.cn/gateway/edi/warehouse/query"
          },
          {
            key: "apiDocDesc.proUrl",
            value:
              "https://sop.jtfulfillment.cn/gateway/edi/warehouse/query"
          },
          { key: "customerid:", value: "CS001" },
          { key: "warehouseCode:", value: "SH.001" },
          { key: "itemCode:", value: "YL001" },
          { key: "eccompanyid:", value: "STANDARD" },
          {
            key: "KEY:",
            value: "MGY3MTU3M2M3NjYxN2RhNjc3NzM4MzM2Y2Q5ZjQ0ZWU="
          }
        ],
        [
          {
            key: "apiDocDesc.testUrlCn",
            value:
              "https://demo-openapi.jtfulfillment.cn/gateway/edi/warehouse/query"
          },
          {
            key: "apiDocDesc.proUrlCn",
            value:
              "https://openapi.jtfulfillment.cn/gateway/edi/warehouse/query"
          },
          { key: "customerid:", value: "UPFOS-TEST" },
          { key: "warehouseCode:", value: "SH.001" },
          { key: "itemCode:", value: "STZX0000001" },
          { key: "eccompanyid:", value: "UPFOS-TEST_PPL" },
          {
            key: "KEY:",
            value: "ZDZmNTM1NWE2ZDQ5NjU4Y2Q4YzY5YWIwZGRjZTEyMzE="
          }
        ]
      ],
      //参数描述  START
      postDataList: [
        //   请求头参数
        {
          title: "onlineDoc.请求参数",
          value: [
            {
              name: "warehouseCode",
              type: "VARCHAR",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.warehouseCodeDesc399"
            },
            {
              name: "customerid",
              type: "VARCHAR",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.customeridDesc400"
            },
            {
              name: "itemCode",
              type: "VARCHAR",
              require: "N",
              normal: "",
              describe: "apiDocDesc.itemCodeDesc401"
            },
            {
              name: "startPage",
              type: "INT",
              require: "N",
              normal: "",
              describe: "apiDocDesc.startPageDesc402"
            },
            {
              name: "pageSize",
              type: "INT",
              require: "N",
              normal: "",
              describe: "apiDocDesc.pageSizeDesc403"
            }
          ]
        }
      ],
      //参数描述  END
      //报文描述 start
      responseDataList: [
        {
          title: "onlineDoc.响应参数",
          value: [
            {
              name: "success",
              type: "VARCHAR",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.successDesc404"
            },
            {
              name: "reason",
              type: "VARCHAR",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.reasonDesc405"
            },
            {
              name: "message",
              type: "VARCHAR",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.messageDesc406"
            },
            {
              name: "total",
              type: "INT",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.totalDesc407"
            },
            {
              name: "baseList",
              type: "ARRAY",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.baseListDesc408",
              children: [
                {
                  name: "warehouseCode",
                  type: "VARCHAR",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.warehouseCodeDesc409"
                },
                {
                  name: "itemCode",
                  type: "VARCHAR",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.itemCodeDesc410"
                },
                {
                  name: "abnormalCount",
                  type: "INT",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.abnormalCountDesc411"
                },
                {
                  name: "totalQuantity",
                  type: "INT",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.totalQuantityDesc412"
                },
                {
                  name: "lockQuantity",
                  type: "INT",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.lockQuantityDesc413"
                },
                {
                  name: "saleQuantity",
                  type: "INT",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.saleQuantityDesc414"
                },
                {
                  name: "pickedQuantity",
                  type: "INT",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.pickedQuantityDesc415"
                },
                {
                  name: "storeQuantity",
                  type: "INT",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.storeQuantityDesc416"
                },
                {
                  name: "locationInventoryList",
                  type: "ARRAY",
                  require: "",
                  normal: "",
                  describe: "apiDocDesc.locationInventoryListDesc417",
                  children: [
                    {
                      name: "batchCode",
                      type: "VARCHAR",
                      require: "N",
                      normal: "",
                      describe: "apiDocDesc.batchCodeDesc418"
                    },
                    {
                      name: "inventoryType",
                      type: "INT",
                      require: "Y",
                      normal: "",
                      describe: "apiDocDesc.inventoryTypeDesc419"
                    },
                    {
                      name: "productDate",
                      type: "DATE",
                      require: "N",
                      normal: "",
                      describe: "apiDocDesc.productDateDesc420"
                    },
                    {
                      name: "expireDate",
                      type: "DATE",
                      require: "N",
                      normal: "",
                      describe: "apiDocDesc.expireDateDesc421"
                    },
                    {
                      name: "produceCode",
                      type: "VARCHAR",
                      require: "N",
                      normal: "",
                      describe: "apiDocDesc.produceCodeDesc422"
                    },
                    {
                      name: "lockQuantity",
                      type: "INT",
                      require: "Y",
                      normal: "",
                      describe: "apiDocDesc.lockQuantityDesc423"
                    },
                    {
                      name: "saleQuantity",
                      type: "INT",
                      require: "Y",
                      normal: "",
                      describe: "apiDocDesc.saleQuantityDesc424"
                    }
                  ]
                }
              ]
            }
          ]
        }
      ],
      //请求示例
      requestCode: {
        warehouseCode: "PHI01",
        customerid: "SJ0002C844",
        itemCode: "NF085,NF083,NF082",
        inventoryType: "ZP",
        batchCode: "xxxx",
        startPage: 1,
        pageSize: 10
      },
      //返回示例
      responseCode: {
        logisticproviderid: "YL",
        traceId: "8d4775bb2705d765dfaf4cfc8fbc28bf",
        responseitems: [
          {
            success: "true",
            reason: "",
            errorMsg: null,
            total: 1,
            pageSize: 100,
            page: 1,
            pages: 1,
            baseList: [
              {
                warehouseCode: "SH.001",
                itemCode: "PC001",
                skuCode: null,
                shortName: null,
                quantity: 248,
                lockQuantity: 110,
                saleQuantity: 229,
                totalQuantity: 248,
                abnormalCount: 12,
                locationInventoryList: [
                  {
                    batchCode:
                      "ylpc1234567890123456789012345678901234567890123456",
                    inventoryType: "ZP",
                    productDate: "2024-01-01",
                    expireDate: "2024-12-31",
                    produceCode:
                      "ylph1234567890123456789012345678901234567890123456",
                    lockQuantity: 1,
                    saleQuantity: 78
                  },
                  {
                    batchCode: "PC123456",
                    inventoryType: "ZP",
                    productDate: "2024-01-01",
                    expireDate: "2024-12-31",
                    produceCode: "PC123456",
                    lockQuantity: 0,
                    saleQuantity: 98
                  },
                  {
                    batchCode: "PC123456789",
                    inventoryType: "ZP",
                    productDate: "2024-01-05",
                    expireDate: "2025-01-04",
                    produceCode: "PC123456",
                    lockQuantity: 100,
                    saleQuantity: 0
                  },
                  {
                    batchCode: "PC123456",
                    inventoryType: "ZP",
                    productDate: "2024-01-01",
                    expireDate: "2024-12-31",
                    produceCode: "PC123456-1",
                    lockQuantity: 0,
                    saleQuantity: 9
                  },
                  {
                    batchCode: "PC123456",
                    inventoryType: "ZP",
                    productDate: "2024-01-18",
                    expireDate: "2025-01-17",
                    produceCode: "PC123456-2",
                    lockQuantity: 0,
                    saleQuantity: 9
                  },
                  {
                    batchCode: "PC123456",
                    inventoryType: "ZP",
                    productDate: "2024-01-11",
                    expireDate: "2025-01-10",
                    produceCode: "PC123456",
                    lockQuantity: 0,
                    saleQuantity: 9
                  },
                  {
                    batchCode: "PC123456789",
                    inventoryType: "ZP",
                    productDate: "2024-01-01",
                    expireDate: "2024-12-31",
                    produceCode: "PC123456",
                    lockQuantity: 0,
                    saleQuantity: 9
                  },
                  {
                    batchCode: "PC123456789",
                    inventoryType: "ZP",
                    productDate: "2024-01-01",
                    expireDate: "2024-12-31",
                    produceCode: "PC123456789",
                    lockQuantity: 0,
                    saleQuantity: 9
                  },
                  {
                    batchCode: "PC789",
                    inventoryType: "ZP",
                    productDate: "2024-01-20",
                    expireDate: "2025-01-19",
                    produceCode: "PC789",
                    lockQuantity: 0,
                    saleQuantity: 9
                  },
                  {
                    batchCode:
                      "ylpc1234567890123456789012345678901234567890123456",
                    inventoryType: "CC",
                    productDate: "2024-01-01",
                    expireDate: "2024-12-31",
                    produceCode:
                      "ylph1234567890123456789012345678901234567890123456",
                    lockQuantity: 0,
                    saleQuantity: 2
                  },
                  {
                    batchCode: "PC123456",
                    inventoryType: "CC",
                    productDate: "2024-01-18",
                    expireDate: "2025-01-17",
                    produceCode: "PC123456-2",
                    lockQuantity: 0,
                    saleQuantity: 1
                  },
                  {
                    batchCode: "PC123456",
                    inventoryType: "CC",
                    productDate: "2024-01-01",
                    expireDate: "2024-12-31",
                    produceCode: "PC123456-1",
                    lockQuantity: 0,
                    saleQuantity: 1
                  },
                  {
                    batchCode: "PC123456",
                    inventoryType: "CC",
                    productDate: "2024-01-01",
                    expireDate: "2024-12-31",
                    produceCode: "PC123456",
                    lockQuantity: 0,
                    saleQuantity: 2
                  },
                  {
                    batchCode: "PC123456",
                    inventoryType: "CC",
                    productDate: "2024-01-11",
                    expireDate: "2025-01-10",
                    produceCode: "PC123456",
                    lockQuantity: 0,
                    saleQuantity: 1
                  },
                  {
                    batchCode:
                      "ylpc1234567890123456789012345678901234567890123456",
                    inventoryType: "exception",
                    productDate: "2024-01-01",
                    expireDate: "2024-12-31",
                    produceCode:
                      "ylph1234567890123456789012345678901234567890123456",
                    lockQuantity: 0,
                    saleQuantity: 1
                  },
                  {
                    batchCode: "PC789",
                    inventoryType: "CC",
                    productDate: "2024-01-20",
                    expireDate: "2025-01-19",
                    produceCode: "PC789",
                    lockQuantity: 0,
                    saleQuantity: 1
                  },
                  {
                    batchCode: "PC123456789",
                    inventoryType: "CC",
                    productDate: "2024-01-01",
                    expireDate: "2024-12-31",
                    produceCode: "PC123456789",
                    lockQuantity: 0,
                    saleQuantity: 1
                  },
                  {
                    batchCode: "PC123456789",
                    inventoryType: "CC",
                    productDate: "2024-01-01",
                    expireDate: "2024-12-31",
                    produceCode: "PC123456",
                    lockQuantity: 0,
                    saleQuantity: 1
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  };
}
